/**
 * lucide-react v0.115.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const Citrus = createLucideIcon("Citrus", [
  [
    "path",
    {
      d: "M5.51 18.49a12 12 0 0 0 16.12.78c.49-.41.49-1.15.03-1.6L6.34 2.33a1.08 1.08 0 0 0-1.6.03A12 12 0 0 0 5.5 18.5Z",
      key: "cpj97m"
    }
  ],
  [
    "path",
    {
      d: "M8.34 15.66a8 8 0 0 0 10.4.78c.54-.4.54-1.16.06-1.64L9.2 5.2c-.48-.48-1.25-.48-1.64.06a8 8 0 0 0 .78 10.4Z",
      key: "vhgi9a"
    }
  ],
  ["path", { d: "m14 10-5.5 5.5", key: "92pfem" }],
  ["path", { d: "M14 10v8", key: "3sxk0t" }],
  ["path", { d: "M14 10H6", key: "1aai03" }]
]);

export { Citrus as default };
//# sourceMappingURL=citrus.js.map
